export default "__VITE_ASSET__DNH$S8oc__"